"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var mobx_react_lite_1 = require("mobx-react-lite");
var react_custom_scrollbars_1 = require("react-custom-scrollbars");
var api_1 = __importDefault(require("api"));
var QueriesStore_1 = require("stores/QueriesStore");
var use_stores_1 = require("hooks/use-stores");
var use_nav_state_1 = require("hooks/use-nav-state");
var navState_1 = require("../../../../contexts/navState");
var use_notification_1 = require("hooks/use-notification");
var Notification_1 = require("components/core/Notification");
var use_dialog_1 = require("hooks/use-dialog");
var Title_1 = __importDefault(require("components/core/common/Title"));
var AccountBar_1 = __importDefault(require("components/core/common/AccountBar"));
var QueryDetailsTabs_1 = __importDefault(require("./QueryDetailsTabs"));
var QueryDetailsStage1_1 = __importDefault(require("./stage-1/QueryDetailsStage1"));
var QueryDetailsStage2_1 = __importDefault(require("./stage-2/QueryDetailsStage2"));
var QueryDetailsBottomButtons_1 = __importDefault(require("./QueryDetailsBottomButtons"));
var QueryComments_1 = __importDefault(require("./QueryComments"));
var Dialog_1 = require("components/core/Dialog");
var QueryDetailsStage3_1 = __importDefault(require("./stage-3/QueryDetailsStage3"));
var QueryDetailsStage4_1 = __importDefault(require("./stage-4/QueryDetailsStage4"));
var QueryDetails = mobx_react_lite_1.observer(function () {
    var _a = use_stores_1.useStores(), userStore = _a.userStore, queriesStore = _a.queriesStore;
    var _b = react_1.useState(null), activeQuery = _b[0], setActiveQuery = _b[1];
    var _c = react_1.useState("1"), activeTabBuffer = _c[0], setActiveTabBuffer = _c[1];
    var _d = react_1.useState("1"), activeTab = _d[0], setActiveTab = _d[1];
    var _e = react_1.useState(""), changing = _e[0], setChanging = _e[1];
    var _f = react_1.useState(false), commentsVisible = _f[0], setCommentsVisible = _f[1];
    var history = react_router_dom_1.useHistory();
    var params = react_router_dom_1.useParams();
    var navState = use_nav_state_1.useNavState();
    var notification = use_notification_1.useNotification();
    var dialog = use_dialog_1.useDialog();
    react_1.useEffect(function () {
        if (queriesStore.data.length <= 0) {
            api_1.default.getQuery(params.id)
                .then(function (response) {
                queriesStore.setData([
                    response.data
                ]);
            });
        }
        navState.saveState(navState_1.NavState.COLLAPSED);
    }, []);
    react_1.useEffect(function () {
        for (var _i = 0, _a = queriesStore.data; _i < _a.length; _i++) {
            var query = _a[_i];
            if (query.id === parseInt(params.id)) {
                setActiveQuery(query);
                break;
            }
        }
    }, [queriesStore.data]);
    react_1.useEffect(function () {
        for (var _i = 0, _a = queriesStore.data; _i < _a.length; _i++) {
            var query = _a[_i];
            if (query.id === parseInt(params.id)) {
                setActiveQuery(query);
                query.queryStage !== null &&
                    setActiveTabBuffer(query.queryStage.stage.toString());
                break;
            }
        }
    }, [params.id, queriesStore.data.length]);
    var logoutHandler = function () {
        userStore.unsetData();
        history.replace("/login");
    };
    var changeTabHandler = function (e) {
        if (e.currentTarget.dataset.inactive === "true")
            return;
        setActiveTabBuffer(e.currentTarget.dataset.tab);
    };
    react_1.useEffect(function () {
        if (activeTabBuffer === activeTab)
            return;
        setChanging("changing");
        var timer = setTimeout(function () {
            setActiveTab(activeTabBuffer);
            setChanging("");
        }, 150);
        return function () { return clearTimeout(timer); };
    }, [activeTabBuffer]);
    var renderStage = function () {
        switch (parseInt(activeTab)) {
            case 1:
                return react_1.default.createElement(QueryDetailsStage1_1.default, { data: activeQuery });
            case 2:
                return react_1.default.createElement(QueryDetailsStage2_1.default, { data: activeQuery });
            case 3:
                return react_1.default.createElement(QueryDetailsStage3_1.default, { data: activeQuery });
            case 4:
                return react_1.default.createElement(QueryDetailsStage4_1.default, { data: activeQuery });
            default: return null;
        }
    };
    var sendForwardHandler = function (stage) {
        if (stage === 2 && activeQuery.queryType.id === QueriesStore_1.QueryTypes.PRICE &&
            activeQuery.priceQuery.priceQueryIPCs.length <= 0 ||
            stage === 2 && activeQuery.queryType.id === QueriesStore_1.QueryTypes.FLEET &&
                activeQuery.fleetQuery.fleetQueryIPCs.length <= 0) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Please enter at least 1 IPC row"
            });
            return;
        }
        if (stage === 2 && activeQuery.queryType.id === QueriesStore_1.QueryTypes.PRICE &&
            activeQuery.dueDate === null ||
            stage === 2 && activeQuery.queryType.id === QueriesStore_1.QueryTypes.FLEET &&
                activeQuery.dueDate === null) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Please enter a due date"
            });
            return;
        }
        if (stage === 2 && activeQuery.queryType.id === QueriesStore_1.QueryTypes.PRICE &&
            activeQuery.priceQuery.queryAction === null ||
            stage === 2 && activeQuery.queryType.id === QueriesStore_1.QueryTypes.FLEET &&
                activeQuery.fleetQuery.queryAction === null) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Please choose a Query Action"
            });
            return;
        }
        if (stage === 2 && activeQuery.queryType.id === QueriesStore_1.QueryTypes.FLEET &&
            activeQuery.fleetQuery.initialAuthoriser === null) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Please choose an initial Authoriser"
            });
            return;
        }
        dialog({
            variant: Dialog_1.DialogVariants.CONFIRMATION,
            title: "Send this query forward?",
            description: "Are you sure you want to send this query forward? Please make sure all details are correct and leave your comments below.",
            withComment: true,
            queryId: activeQuery.id,
            stage: activeQuery.currentStage,
            direction: "Forward"
        })
            .then(function (response) {
            api_1.default.sendQueryForward(activeQuery.id, { currentStage: stage })
                .then(function (response) {
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: "Successfully sent query forward"
                });
                queriesStore.editDataItem(response.data);
                history.replace("/?recent=" + activeQuery.id);
            }, function (error) {
                notification({
                    variant: Notification_1.NotificationVariants.ERROR,
                    message: error.response.data.message || error.response.data.title
                });
            });
        });
    };
    var sendBackHandler = function (stage) {
        dialog({
            variant: Dialog_1.DialogVariants.CONFIRMATION,
            title: "Send this query backwards?",
            description: "Are you sure you want to send this query back? If you wish to leave a comment, please do so in the \"Comments\" tab in the bottom right of the screen.",
            withComment: true,
            queryId: activeQuery.id,
            stage: activeQuery.currentStage,
            direction: "Backward"
        })
            .then(function (response) {
            api_1.default.sendQueryBack(activeQuery.id, { currentStage: stage })
                .then(function (response) {
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: "Successfully sent query back"
                });
                queriesStore.editDataItem(response.data);
                history.replace("/?recent=" + activeQuery.id);
            }, function (error) {
                notification({
                    variant: Notification_1.NotificationVariants.ERROR,
                    message: error.response.data.message || error.response.data.title
                });
            });
        });
    };
    var altSendForwardHandler = function (part) {
        if (activeQuery.podQuery.dummyOrderRequired && activeQuery.podQuery.podQueryIPCs.length <= 0 && part === 'warehouse1') {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Please enter at least 1 Dummy Order IPC row"
            });
            return;
        }
        else if (activeQuery.podQuery.dummyOrderRequired && part === 'credit') {
            for (var i = 0; i < activeQuery.podQuery.podQueryIPCs.length; i++) {
                if (activeQuery.podQuery.podQueryIPCs[i].creditText === null || activeQuery.podQuery.podQueryIPCs[i].creditText === "") {
                    notification({
                        variant: Notification_1.NotificationVariants.ERROR,
                        message: "Please enter the Line Item Text for all IPC rows"
                    });
                    return;
                }
            }
        }
        else if (activeQuery.podQuery.dummyOrderRequired && part === 'customerServices') {
            for (var i = 0; i < activeQuery.podQuery.podQueryIPCs.length; i++) {
                if (activeQuery.podQuery.podQueryIPCs[i].orderNumberReturnRef === null
                    || activeQuery.podQuery.podQueryIPCs[i].orderNumberReturnRef === "") {
                    notification({
                        variant: Notification_1.NotificationVariants.ERROR,
                        message: "Please enter the Dummy Order Number for all IPC rows"
                    });
                    return;
                }
            }
        }
        else if (activeQuery.podQuery.dummyOrderRequired && part === 'warehouse2') {
            for (var i = 0; i < activeQuery.podQuery.podQueryIPCs.length; i++) {
                if (activeQuery.podQuery.podQueryIPCs[i].goodsIssue === null) {
                    notification({
                        variant: Notification_1.NotificationVariants.ERROR,
                        message: "Please enter if Goods have been issued for all IPC row"
                    });
                    return;
                }
            }
        }
        dialog({
            variant: Dialog_1.DialogVariants.CONFIRMATION,
            title: "Send this query forward?",
            description: "Are you sure you want to send this query forward? Please make sure all details are correct. If you wish to leave a comment, please do so in the \"Comments\" tab in the bottom right of the screen.",
            withComment: true,
            queryId: activeQuery.id,
            stage: activeQuery.currentStage,
            direction: "Forward"
        })
            .then(function (response) {
            api_1.default.sendQueryForward(activeQuery.id, { currentStage: 3, currentStage3: part })
                .then(function (response) {
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: "Successfully sent query forward"
                });
                queriesStore.editDataItem(response.data);
                history.replace("/?recent=" + activeQuery.id);
            }, function (error) {
                notification({
                    variant: Notification_1.NotificationVariants.ERROR,
                    message: error.response.data.message || error.response.data.title
                });
            });
        });
    };
    var altSendBackHandler = function (part) {
        dialog({
            variant: Dialog_1.DialogVariants.CONFIRMATION,
            title: "Send this query backwards?",
            description: "Are you sure you want to send this query back? If you wish to leave a comment, please do so in the \"Comments\" tab in the bottom right of the screen.",
            withComment: true,
            queryId: activeQuery.id,
            stage: activeQuery.currentStage,
            direction: "Backward"
        })
            .then(function (response) {
            api_1.default.sendQueryBack(activeQuery.id, { currentStage: 3, currentStage3: part })
                .then(function (response) {
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: "Successfully sent query back"
                });
                queriesStore.editDataItem(response.data);
                history.replace("/?recent=" + activeQuery.id);
            }, function (error) {
                notification({
                    variant: Notification_1.NotificationVariants.ERROR,
                    message: error.response.data.message || error.response.data.title
                });
            });
        });
    };
    return (activeQuery !== null ?
        react_1.default.createElement("div", { className: "page query-details flex flex-column" },
            react_1.default.createElement(Title_1.default, null, "Query Log"),
            react_1.default.createElement(AccountBar_1.default, { user: userStore.data, logout: logoutHandler }),
            react_1.default.createElement("div", { className: "query-details__container" },
                react_1.default.createElement("div", { className: "query-details__content flex flex-column" },
                    react_1.default.createElement(QueryDetailsTabs_1.default, { stage: activeQuery.queryStage.stage, active: activeTab, onChange: changeTabHandler }),
                    react_1.default.createElement("div", { className: "query-details__stages" },
                        react_1.default.createElement(react_custom_scrollbars_1.Scrollbars, null,
                            react_1.default.createElement("div", { className: "query-details__stages__content", "data-changing": changing }, renderStage()))),
                    react_1.default.createElement(QueryDetailsBottomButtons_1.default, { activeTab: activeTab, query: activeQuery, userStore: userStore, onChangeTab: changeTabHandler, onSendForward: sendForwardHandler, onSendBack: sendBackHandler, onAltSendForward: altSendForwardHandler, onAltSendBack: altSendBackHandler }))),
            react_1.default.createElement(QueryComments_1.default, { visible: commentsVisible, comments: activeQuery !== null && activeQuery.queryComments || [], onToggleVisibility: function () { setCommentsVisible(!commentsVisible); } }))
        :
            null);
});
exports.default = QueryDetails;
